<a class="nav-link" (click)="toggleOpen()">
  <i class="now-ui-icons ui-1_bell-53" [matBadge]="newCommandsCount" [matBadgeHidden]="newCommandsCount < 1" matBadgeColor="primary"></i>
</a>

@if (isOpen) {
  <div class="notification-bell-panel">
    @if (viewModel$ | async; as vm) {
      @if (vm.currentId || vm.pendingSend || vm.historyIds.length > 0) {
        <div class="current-message">
          @if (vm.currentId) {
            <app-message-result [messageId]="vm.currentId" (completed)="scheduleAutoClose()"></app-message-result>
          } @else if (vm.pendingSend) {
            <div class="message-result-header">
              <span class="message-result-status status-running">Running…</span>
            </div>
          }

          @if (vm.historyIds.length > 0) {
            <button type="button" class="history-toggle" title="History" (click)="toggleHistory()">
              <mat-icon>{{ historyExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          }
        </div>

        @if (historyExpanded && vm.historyIds.length > 0) {
          <div class="history-list">
            @for (messageId of vm.historyIds; track messageId) {
              <app-message-result [messageId]="messageId"></app-message-result>
            }
          </div>
        }
      } @else {
        <p class="notification-bell-empty">No recent commands.</p>
      }
    }
  </div>
}
